import './style.css';
import iphoneImage from './images/cursorr_app_mokup.png';
import logo from './images/5696349.png';
import feature_1 from './images/ic_mouse_2d.png';
import feature_2 from './images/ic_mouse_3d.png';
import feature_3 from './images/round_touch_app_white_24dp.png';
import feature_4 from './images/round_view_week_white_24dp.png';
import feature_5 from './images/round_volume_up_white_24dp.png';
import feature_6 from './images/round_brightness_medium_white_24dp.png';
import { ReactComponent as IcWindowsLogo } from './images/ic_windows.svg';
import { ReactComponent as IcGooglePlayLogo } from './images/ic_google_play.svg';
import { Component } from 'react';

class App extends Component {

  render() {

    return (
      <div className="App">
        <header className="App-header">
          <div className="body-wrap boxed-container">
            <header className="site-header">
              <div className="container">
                <div className="site-header-inner">
                  <div className="brand header-brand">
                    <h1 className="m-0">
                      <a href="#">
                      </a>
                    </h1>
                  </div>
                </div>
              </div>
            </header>

            <main>
              <section className="hero">
                <div className="container">
                  <div className="hero-inner">
                    <div className="hero-copy">
                      <img className="app-logo" width="56" height="56" src={logo} />
                      <h1 className="hero-title mt-0"><strong>Cursorr</strong>: Gyroscopic mouse &amp; Touchpad</h1>
                      <p className="hero-paragraph">Cursorr is an application that allows you to use your phone as a mouse for your pc. You can move the cursor by using the screen of your phone as a touchpad or by using the sensors of your phone and pointing it at your pc monitor like a laser.</p>
                      <div className="hero-cta">
                        <a className="button button-shadow button-large" href="https://github.com/MariusBinary/Cursorr/releases/download/v1.4.0.0/cursorr-1.4-setup-x32.exe">
                          <IcWindowsLogo />
                          Download Server</a>
                        <a className="button button-primary button-shadow" href="https://play.google.com/store/apps/details?id=mariusbinary.cursorr">
                          <IcGooglePlayLogo />
                          Google Play</a>
                      </div>
                      <div class="overlay-dialog-center">
                        <p class="hero-paragraph hero-alert">
                          The application has not been signed with a valid certificate and therefore the browser or Windows may flag the application as dangerous to install. We want to ensure you that the application does not contain any threats and if you don't trust us you can find the source code on github to compile it yourself and run the app.
                        </p>
                        <a class="button button-shadow button-alert" href="https://github.com/MariusBinary/Cursorr">
                          <svg height="32" aria-hidden="true" viewBox="0 0 16 16" version="1.1" width="32" data-view-component="true" class="octicon octicon-mark-github v-align-middle">
                            <path fill-rule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"></path>
                          </svg>
                          Source code on GitHub
                        </a>
                      </div>
                    </div>
                    <div className="hero-app">
                      <div className="hero-app-illustration">
                        <svg width="999" height="931" version="1.1" >
                          <defs>
                            <linearGradient id="hero-shape-a" x1=".92827" x2=".53422" y2=".80087">
                              <stop stopColor="#f5c51d" offset="0" />
                              <stop stopColor="#F97C58" stopOpacity="0" offset="1" />
                            </linearGradient>
                            <linearGradient id="hero-shape-b" x1="92.827%" x2="53.406%" y2="80.12%">
                              <stop stopColor="#47A1F9" offset="0" />
                              <stop stopColor="#F9425F" stopOpacity="0" offset=".80532" />
                              <stop stopColor="#FDFFDA" stopOpacity="0" offset="1" />
                            </linearGradient>
                            <linearGradient id="hero-shape-c" x1="8.685%" x2="85.808%" y1="23.733%" y2="82.837%">
                              <stop stopColor="#FFF" stopOpacity=".48" offset="0" />
                              <stop stopColor="#FFF" stopOpacity="0" offset="1" />
                            </linearGradient>
                            <linearGradient id="hero-shape-d" x1=".79483" x2=".3842" y1=".15903" y2=".70124">
                              <stop stopColor="#ffa522" offset="0" />
                              <stop stopColor="#FDFFDA" stopOpacity="0" offset="1" />
                            </linearGradient>
                            <linearGradient id="hero-shape-e" x1="99.037%" x2="24.582%" y1="26.963%" y2="78.557%">
                              <stop stopColor="#FDFFDA" stopOpacity=".64" offset="0" />
                              <stop stopColor="#F97C58" stopOpacity=".24" offset=".42952" />
                              <stop stopColor="#F9425F" stopOpacity="0" offset="1" />
                            </linearGradient>
                            <linearGradient id="linearGradient1314" x1=".92827" x2=".53406" y2=".8012">
                              <stop stopColor="#ffb931" offset="0" />
                              <stop stopColor="#dc7e3e" stopOpacity="0" offset=".80532" />
                              <stop stopColor="#FDFFDA" stopOpacity="0" offset="1" />
                            </linearGradient>
                          </defs>
                          <g fill="none" fillRule="evenodd">
                            <g className="hero-shape-top">
                              <g className="is-moving-object is-translating" data-translating-factor="280">
                                <path transform="translate(1)" d="m680.19 0c-23.36 69.79-58.473 98.3-105.34 85.531-70.301-19.152-189.72-21.734-252.4 91.442-62.676 113.18-144.1 167.83-215.2 118.57-47.399-32.841-83.15-7.693-107.25 75.445l306.18 195.42c207.16-4.242 305.67-51.612 295.52-142.11-10.152-90.497 34.533-163.55 134.05-219.16l4.512-119.61-60.082-85.531z" fill="url(#hero-shape-a)" />
                              </g>
                              <g className="is-moving-object is-translating" data-translating-factor="100">
                                <path transform="rotate(-53 507.64 504.2)" d="m817.19 222c-23.36 69.79-58.473 98.3-105.34 85.531-70.301-19.152-189.72-21.734-252.4 91.442-62.676 113.18-144.1 167.83-215.2 118.57-47.399-32.841-83.15-7.693-107.25 75.445l306.18 195.42c207.16-4.242 305.67-51.612 295.52-142.11-10.152-90.497 34.533-163.55 134.05-219.16l4.512-119.61-60.082-85.531z" fill="url(#linearGradient1314)" />
                              </g>
                            </g>
                            <g transform="translate(191 416)">
                              <g className="is-moving-object is-translating" data-translating-factor="50">
                                <circle cx="336" cy="190" r="190" fill="url(#hero-shape-c)" />
                              </g>
                              <g className="is-moving-object is-translating" data-translating-factor="80">
                                <path d="m683.77 133.04c-112.05-90.805-184.69-76.302-217.92 43.508-33.23 119.81-125.47 124.8-276.72 14.972-3.156 120.36 53.893 200.09 171.15 239.2 175.88 58.67 346.7-130.4 423.78-239.2 51.388-72.536 17.96-92.03-100.28-58.48z" fill="url(#hero-shape-d)" />
                              </g>
                              <g className="is-moving-object is-translating" data-translating-factor="100">
                                <path transform="matrix(-1 0 0 1 597.61 0)" d="m448.21 223.25c-97.52-122.94-154.27-117.43-170.26 16.55-15.988 133.98-108.23 138.97-276.72 14.973-9.255 95.477 47.794 175.21 171.15 239.2 185.03 95.989 424.99-180.11 424.99-239.2 0-39.396-49.717-49.904-149.15-31.523z" fill="url(#hero-shape-e)" />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <img className="device-mockup" src={iphoneImage} alt="App preview" />
                      <div className="hero-app-dots hero-app-dots-1">
                        <svg width="124" height="75" xmlns="http://www.w3.org/2000/svg">
                          <g fill="none" fillRule="evenodd">
                            <path fill="#FFF" d="M33.392 0l3.624 1.667.984 3.53-1.158 3.36L33.392 10l-3.249-1.639L28 5.196l1.62-3.674z" />
                            <path fill="#7487A3" d="M74.696 3l1.812.833L77 5.598l-.579 1.68L74.696 8l-1.624-.82L72 5.599l.81-1.837z" />
                            <path fill="#556B8B" d="M40.696 70l1.812.833.492 1.765-.579 1.68-1.725.722-1.624-.82L38 72.599l.81-1.837z" />
                            <path fill="#7487A3" d="M4.314 37l2.899 1.334L8 41.157l-.926 2.688L4.314 45l-2.6-1.31L0 41.156l1.295-2.94zM49.314 32l2.899 1.334.787 2.823-.926 2.688L49.314 40l-2.6-1.31L45 36.156l1.295-2.94z" />
                            <path fill="#556B8B" d="M99.696 56l1.812.833.492 1.765-.579 1.68-1.725.722-1.624-.82L97 58.599l.81-1.837zM112.696 37l1.812.833.492 1.765-.579 1.68-1.725.722-1.624-.82L110 39.599l.81-1.837zM82.696 37l1.812.833.492 1.765-.579 1.68-1.725.722-1.624-.82L80 39.599l.81-1.837zM122.618 57l1.087.5.295 1.059-.347 1.008-1.035.433-.975-.492-.643-.95.486-1.101z" />
                          </g>
                        </svg>
                      </div>
                      <div className="hero-app-dots hero-app-dots-2">
                        <svg width="124" height="75" xmlns="http://www.w3.org/2000/svg">
                          <g fill="none" fillRule="evenodd">
                            <path fill="#556B8B" d="M33.392 0l3.624 1.667.984 3.53-1.158 3.36L33.392 10l-3.249-1.639L28 5.196l1.62-3.674zM74.696 3l1.812.833L77 5.598l-.579 1.68L74.696 8l-1.624-.82L72 5.599l.81-1.837zM40.696 70l1.812.833.492 1.765-.579 1.68-1.725.722-1.624-.82L38 72.599l.81-1.837zM4.314 37l2.899 1.334L8 41.157l-.926 2.688L4.314 45l-2.6-1.31L0 41.156l1.295-2.94zM49.314 32l2.899 1.334.787 2.823-.926 2.688L49.314 40l-2.6-1.31L45 36.156l1.295-2.94z" />
                            <path fill="#FFF" d="M99.696 56l1.812.833.492 1.765-.579 1.68-1.725.722-1.624-.82L97 58.599l.81-1.837z" />
                            <path fill="#556B8B" d="M112.696 37l1.812.833.492 1.765-.579 1.68-1.725.722-1.624-.82L110 39.599l.81-1.837z" />
                            <path fill="#FFF" d="M82.696 37l1.812.833.492 1.765-.579 1.68-1.725.722-1.624-.82L80 39.599l.81-1.837z" />
                            <path fill="#556B8B" d="M122.618 57l1.087.5.295 1.059-.347 1.008-1.035.433-.975-.492-.643-.95.486-1.101z" />
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section className="features section">
                <div className="container">
                  <div className="features-inner section-inner has-bottom-divider">
                    <h2 className="section-title mt-0">Features</h2>
                    <div className="features-wrap">
                      <div className="feature is-revealing">
                        <div className="feature-inner">
                          <div className="feature-icon">
                            <img width="64" height="64" src={feature_1} />
                          </div>
                          <h3 className="feature-title mt-24">Touchpad</h3>
                          <p className="text-sm mb-0">You have a touchpad at your disposal thanks to which you can move the cursor on your pc just by touching the screen of your phone.</p>
                        </div>
                      </div>
                      <div className="feature is-revealing">
                        <div className="feature-inner">
                          <div className="feature-icon">
                            <img width="64" height="64" src={feature_2} />
                          </div>
                          <h3 className="feature-title mt-24">Gyroscope</h3>
                          <p className="text-sm mb-0">If you find it easier, you can always move the cursor by simply pointing the phone at your pc screen.</p>
                        </div>
                      </div>
                      <div className="feature is-revealing">
                        <div className="feature-inner">
                          <div className="feature-icon">
                            <img width="64" height="64" src={feature_3} />
                          </div>
                          <h3 className="feature-title mt-24">Gestures</h3>
                          <p className="text-sm mb-0">The application provides you with many gestures that you can use on the touchpad (e.g. tap, double tap, swipe with two fingers).</p>
                        </div>
                      </div>
                      <div className="feature is-revealing">
                        <div className="feature-inner">
                          <div className="feature-icon">
                            <img width="64" height="64" src={feature_4} />
                          </div>
                          <h3 className="feature-title mt-24">Buttons</h3>
                          <p className="text-sm mb-0">If you are not a gesture type, you can use the classic buttons that you find at the bottom of the application.</p>
                        </div>
                      </div>
                      <div className="feature is-revealing">
                        <div className="feature-inner">
                          <div className="feature-icon">
                            <img width="64" height="64" src={feature_5} />
                          </div>
                          <h3 className="feature-title mt-24">Volume</h3>
                          <p className="text-sm mb-0">You can also use the physical buttons on your phone to raise and lower the volume on your PC.</p>
                        </div>
                      </div>
                      <div className="feature is-revealing">
                        <div className="feature-inner">
                          <div className="feature-icon">
                            <img width="64" height="64" src={feature_6} />
                          </div>
                          <h3 className="feature-title mt-24">Themes</h3>
                          <p className="text-sm mb-0">Personalization is a very important thing. Change the theme from dark to light or just let it follow your system.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section className="newsletter section">
                <div className="container">
                  <div className="newsletter-inner section-inner">
                    <h2 className="section-title mt-0">How to use:</h2>
                    <ol type="1">
                      <li>Download and install the server on your pc from this website or from the Github page.</li>
                      <li>Download and install the app on your android phone from Google Play.</li>
                      <li>Make sure your pc and phone are connected to the same wifi network.</li>
                      <li>Start the server on your pc.</li>
                      <li>If the server started correctly, you will be able to see it appear automatically within the application on your phone.</li>
                      <li>Tap on the server and use Cursorr.</li>
                    </ol>
                  </div>
                </div>
              </section>

              <section className="newsletter section">
                <div className="container">
                  <div className="newsletter-inner section-inner">
                    <h2 className="section-title mt-0">Need Help ?</h2>
                    <div className="newsletter-header">
                      <h2 className="mt-0">What can I do if the server is not automatically detected?</h2>
                      <p className="section-paragraph">If your device is not automatically detected by the application, first make sure you are connected to the same wifi network. If this is already the case, add the server manually from the application by clicking on the button "Not found? Add it manually" at the bottom of the page and enter the IP address provided by the server.</p>
                    </div>
                    <div className="newsletter-header">
                      <h2 className="mt-0">What can I do if the cursor movement is not smooth or freezes?</h2>
                      <p className="section-paragraph">If the movement of the cursor is not smooth or freezes, the problem is the latency between the PC and the phone. To get good performance try to be as close as possible to the wifi router.</p>
                    </div>
                    <div className="newsletter-header">
                      <h2 className="mt-0">Does the application works in hotspot?</h2>
                      <p className="section-paragraph">Yes, but if the device that is doing hotspot is the same on which you want to use the application, the server will not be detected automatically and you will have add it by to entering the IP address manually.</p>
                    </div>
                    <div className="newsletter-header">
                      <h2 className="mt-0">Does the application support connection via bluetooth?</h2>
                      <p className="section-paragraph">No, at the moment the application does not support connection via bluetooth.</p>
                    </div>
                  </div>
                </div>
              </section>
            </main>

            <footer className="site-footer">
              <div className="container">
                <div className="site-footer-inner has-top-divider">
                  <ul className="footer-links list-reset">
                    <li>
                      <a href="#">Cursorr: Gyroscopic Mouse &amp; Touchpad</a>
                    </li>
                  </ul>
                  <div className="footer-copyright"><a href="https://www.mariusbinary.altervista.org/applications.php">Visit the <strong>MariusBinary</strong> website for more projects.</a></div>
                </div>
              </div>
            </footer>
          </div>
        </header>
      </div>
    );
  }
}

export default App;
